import { prefersReducedMotion } from '@kame/lib';

const IMPACT_MS = 1100;
const FADE_MS = 750;

class KameEnergyBeam extends HTMLElement {
  connectedCallback() {
    if (prefersReducedMotion()) return;
    this.classList.add('is-armed');
    this.observer = new IntersectionObserver(([entry]) => this.fire(entry.isIntersecting), {
      rootMargin: '0px 0px -45% 0px',
    });
    this.observer.observe(this);
  }

  fire(on) {
    const firing = this.classList.contains('is-firing');
    if (on === firing) return;
    clearTimeout(this.impactTimer);
    clearTimeout(this.fadeTimer);
    this.classList.toggle('is-firing', on);
    this.classList.remove('is-impacted', 'is-fading');
    if (!on) {
      this.classList.add('is-fading');
      this.fadeTimer = setTimeout(() => this.classList.remove('is-fading'), FADE_MS);
      return;
    }
    this.impactTimer = setTimeout(() => {
      this.classList.add('is-impacted');
      this.dispatchEvent(new CustomEvent('kame:beam-impact', { bubbles: true }));
    }, IMPACT_MS);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    clearTimeout(this.impactTimer);
    clearTimeout(this.fadeTimer);
  }
}

if (!customElements.get('kame-energy-beam')) customElements.define('kame-energy-beam', KameEnergyBeam);
